import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
// import axios from "axios";
import axios from "../../../context/axios";
import { initTE, Ripple } from "tw-elements";

const TourNav = () => {
  const [categories, setCategories] = useState([]);
  const [states, setStates] = useState([]); // unused for now
  const [showAll, setShowAll] = useState(false);
  const location = useLocation();
  const [activeCategory, setActiveCategory] = useState(null);
  const [categoryTours, setCategoryTours] = useState([]);
  // Ref for the scroll container
  const packageContainerRef = useRef(null);

  useEffect(() => {
    const fetchTours = async () => {
      if (!activeCategory) return;

      try {
        const response = await axios.post("/tours/by-category", {
          categoryId: activeCategory,
        });
        setCategoryTours(response.data);
      } catch (error) {
        console.error("Failed to fetch tours for category:", error);
      }
    };

    fetchTours();
  }, [activeCategory]);

  useEffect(() => {
    initTE({ Ripple });

    const fetchData = async () => {
      try {
        const [catRes, stateRes] = await Promise.all([
          axios.get("/categories"),
          axios.get("/states"),
        ]);

        setCategories(catRes.data);
        if (catRes.data.length > 0) {
          setActiveCategory(catRes.data[0]._id); // default category
        }
        setStates(stateRes.data);
      } catch (error) {
        console.error("Failed to fetch categories or states:", error);
      }
    };

    fetchData();
  }, []);
  const handleCategoryClick = (categoryId) => {
    setActiveCategory(categoryId);
  };
  const activePath =
    location.pathname || (categories.length > 0 ? categories[0].path : "");

  // Scroll helpers
  const scrollLeft = () => {
    if (packageContainerRef.current) {
      packageContainerRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (packageContainerRef.current) {
      packageContainerRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  // Split categories for nav
  const firstCategories = categories.slice(0, 7);
  const remainingCategories = categories.slice(7);

  return (
    <>
      {/* Categories Navigation */}
      {/* <nav className="w-screen py-2 bg-white sticky top-0 z-10 shadow-sm">
        <div className="flex flex-wrap items-center space-x-4 px-4 md:px-8 overflow-x-auto no-scrollbar">
          {firstCategories.map((cat) => (
            <button
              key={cat._id}
              onClick={() => handleCategoryClick(cat._id)}
              className={`px-4 py-2 rounded-md text-sm font-semibold ${
                activeCategory === cat._id
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 text-gray-800 hover:bg-blue-200"
              }`}
            >
              {cat.name}
            </button>
          ))}

          {remainingCategories.length > 0 && (
            <>
              {!showAll && (
                <button
                  className="px-4 py-2 rounded-full bg-gray-200 text-gray-700 text-sm font-semibold hover:bg-gray-300 whitespace-nowrap"
                  aria-label="Show more categories"
                  onClick={() => setShowAll(true)}
                >
                  + More
                </button>
              )}

              {showAll &&
                remainingCategories.map((cat) => (
                  <button
                    key={cat._id}
                    onClick={() => handleCategoryClick(cat._id)}
                    className={`px-4 py-2 rounded-full whitespace-nowrap text-sm gap-20 font-semibold transition ${
                      activeCategory === cat._id
                        ? "bg-blue-600 text-white"
                        : "bg-gray-100 text-gray-800 hover:bg-blue-100"
                    }`}
                  >
                    {cat.name || cat.display}
                  </button>
                ))}
            </>
          )}
        </div>
      </nav> */}
      <nav className="w-full py-3 bg-white sticky top-0 z-10 shadow-sm">
  <div className="flex flex-wrap gap-2 items-center px-4 md:px-8 overflow-x-auto no-scrollbar">
    {firstCategories.map((cat) => (
      <button
        key={cat._id}
        onClick={() => handleCategoryClick(cat._id)}
        className={`px-4 py-2 rounded-md text-sm font-semibold whitespace-nowrap ${
          activeCategory === cat._id
            ? "bg-blue-600 text-white"
            : "bg-gray-100 text-gray-800 hover:bg-blue-200"
        }`}
      >
        {cat.name}
      </button>
    ))}

    {remainingCategories.length > 0 && (
      <>
        {!showAll && (
          <button
            className="px-4 py-2 rounded-md bg-gray-200 text-gray-700 text-sm font-semibold hover:bg-gray-300 whitespace-nowrap"
            onClick={() => setShowAll(true)}
          >
            + More
          </button>
        )}

        {showAll &&
          remainingCategories.map((cat) => (
            <button
              key={cat._id}
              onClick={() => handleCategoryClick(cat._id)}
              className={`px-4 py-2 rounded-md whitespace-nowrap text-sm font-semibold transition ${
                activeCategory === cat._id
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 text-gray-800 hover:bg-blue-100"
              }`}
            >
              {cat.name || cat.display}
            </button>
          ))}
      </>
    )}
  </div>
</nav>

      {/* Packages Section */}
      <section className="w-full mt-6 relative">
        {/* Scroll Buttons */}
        <button
          onClick={scrollLeft}
          aria-label="Scroll packages left"
          className="absolute left-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 z-20"
          style={{ boxShadow: "0 0 6px rgba(0,0,0,0.15)" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>

        <button
          onClick={scrollRight}
          aria-label="Scroll packages right"
          className="absolute right-0 top-1/2 -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 z-20"
          style={{ boxShadow: "0 0 6px rgba(0,0,0,0.15)" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-gray-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>

        {/* Packages Container */}
        <div
          ref={packageContainerRef}
          className="flex space-x-6 overflow-x-auto no-scrollbar px-6 py-4"
          style={{ scrollBehavior: "smooth" }}
        >
          {categoryTours.map((tour) => (
            <Link
              to={`/tours/${tour._id}`}
              key={tour._id}
              className="min-w-[250px] max-w-[250px] rounded-lg shadow-md bg-white hover:shadow-xl transition-shadow duration-300 cursor-pointer flex-shrink-0"
            >
              <img
                src={tour.img}
                alt={tour.title}
                className="w-full h-40 object-cover rounded-t-lg"
              />
              <div className="p-4">
                <h3 className="text-lg font-semibold mb-1">{tour.title}</h3>
                <p className="text-gray-600 text-sm">
                  {tour.duration?.day} Days &nbsp;|&nbsp; {tour.duration?.night}{" "}
                  Nights
                </p>
              </div>
            </Link>
          ))}

          {/* "+ More" Card */}
          {/* <div className="min-w-[250px] max-w-[250px] rounded-lg shadow-md bg-gray-100 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-200 transition-colors duration-300 flex-shrink-0">
            <div className="text-5xl font-bold text-gray-600 select-none">
              +
            </div>
            <p className="mt-2 text-lg font-semibold text-gray-700 select-none">
              More
            </p>
          </div> */}
        </div>
      </section>

      {/* Global styles to hide scrollbar but allow scroll */}
      <style>{`
        .no-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .no-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </>
  );
};

export default TourNav;
